'use client';

import { AfterPayScript } from '../AfterPayScript';
import { MedalliaScript } from '../MedalliaScript';
import { AdyenDataCollectionScript } from '../AdyenDataCollectionScript/AdyenDataCollectionScript';
import { UsableNetScript } from '../UsableNetScript';
import { useWebView } from '../../hooks/useWebView';

export function BodyStartScripts() {
    const isWebView = useWebView();

    return (
        <>
            {!isWebView && <MedalliaScript />}
            <AdyenDataCollectionScript />
            <AfterPayScript />
            <UsableNetScript />
        </>
    );
}
